/**
 * Client-side widget counters (spec-widget-mcp §9: `widget_fallback_v1`, `widget_shown_v1`,
 * `widget_abandoned_v1`). The messenger has no metrics endpoint, so a report is one structured
 * `console.info` line plus a `widget_telemetry` event on the widget's emitter (the seam a future
 * sink subscribes to). Labels are ids, kinds, reasons and indices only — never a field label or value.
 */
import eventEmitter from "./eventEmitter";

const reportedOnce = new Set();

/**
 * @param {string} name e.g. `widget_fallback_v1`
 * @param {Object<string, string|number|boolean>} [labels]
 * @param {{ once?: boolean, onceKey?: string }} [options] `once`: a second report with the same name and
 *   labels (or the same `onceKey`, e.g. a record id that must not become a label) is dropped
 * @returns {boolean} whether it was reported
 */
export function reportWidgetEvent(name, labels = {}, { once = false, onceKey } = {}) {
	const key = `${name}|${onceKey ?? JSON.stringify(labels)}`;
	if (once && reportedOnce.has(key)) return false;
	if (once) reportedOnce.add(key);
	eventEmitter.emit("widget_telemetry", { name, labels });
	console.info(`@@ chat-widget @@ ${name}`, labels);
	return true;
}

/** Tests only. */
export const resetWidgetTelemetry = () => reportedOnce.clear();
